
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import {Component} from 'react';
import { connect } from 'react-redux';
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestNextRacing } from "../../../helpers/terminalRequests/horseRacing";
import { createSelector } from "reselect";

class NextRacing extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_, ownProps) => {
    const key = getSwarmDataKeyForRequest({...getSwarmSubscriptionRequestNextRacing(ownProps.sportId), new: "new"});
    return createSelector([
        state => state.swarmData.data[key] && state.swarmData.data[key],
        state => state.swarmData.loaded[key]
    ],
        (data, loaded) => {
            const dataArray = [];
            const now = Math.floor(Date.now() / 1000);
            if (loaded && data) {
                Object.keys(data.region).filter(item => Object.prototype.hasOwnProperty.call(data.region, item)).forEach(regionId => {
                    const region = data.region[regionId];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).forEach(competitionId => {
                        const competition = region.competition[competitionId];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).forEach(gameId => {
                            const game = competition.game[gameId];
                            dataArray.push({ ...game, regionId, competitionId, gameId, regionAlias: region.alias });
                        });
                    });
                });
                return {
                    data: dataArray.sort((a, b) => a.start_ts - b.start_ts).filter(item => item.start_ts >= now)
                };
            }
            return {
                data: null
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: NextRacing,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestNextRacing(this.props.sportId);
        this.swarmDataKey = getSwarmDataKeyForRequest({...getSwarmSubscriptionRequestNextRacing(this.props.sportId), new: "new"});
    }
}));